
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12280',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12280",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9676",
  "foundations-components": "static-1.7951",
  "foundations-components-legacy": "static-1.976",
  "foundations-theming": "static-1.4425",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8020",
  "hub-http-shared-msw-handlers": "static-1.9974",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11478",
  "I18n": "static-7.1628",
  "jasmine-runner": "static-1.6471",
  "marketplace-storefront-base": "static-1.12341",
  "quartz": "static-1.7042",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16679",
  "reactive-variable-buffer-atom": "static-1.2865",
  "reporting-testing-lib": "static-1.9505",
  "settings-ui-lib": "static-1.12528",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7151",
  "ui-addon-i18n": "static-1.11156",
  "ui-addon-react-router-dom": "static-1.9549",
  "unified-auth": "static-1.500",
  "unified-auth-core-lib": "static-1.782",
  "usage-tracker": "static-1.7351",
  "usage-tracker-core": "static-1.7201",
  "customer-data-property-utils": "static-1.8097",
  "hub-http": "static-1.6229",
  "integrations-lib": "static-1.16156",
  "marketplace-ui-common": "static-1.19729",
  "property-management-iframe": "static-1.13167",
  "quartz-config": "static-1.820",
  "quartz-core": "static-1.6261",
  "quartz-routing": "static-1.472",
  "quick-fetch": "static-1.3920",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4659",
  "ts-schema": "static-1.4083",
  "ui-universal-auth": "static-1.8986",
  "UIComponents": "static-3.8424",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3403",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3319",
  "quartz-webpack": "static-1.3266",
  "bend-plugin-quartz-routing": "static-1.120",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4220",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4872",
  "foundations-theming-specialty": "static-1.2141",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9432",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5348",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1967",
  "ui-fonts": "static-1.740",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-theming": "static-1.2908",
  "foundations-theming-base": "static-1.3410",
  "stylex": "static-1.33",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3131",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4334",
  "ai-components-ui-library": "static-1.8997",
  "ai-rendering-library": "static-1.10190",
  "chirp-fetch": "static-1.1895",
  "connections-embed-lib": "static-1.1005",
  "copilot-toolkit": "static-1.11150",
  "feedback-loader": "static-1.29309",
  "laboratory-lib": "static-3.7163",
  "marketplace-embed": "static-1.22101",
  "marketplace-ui-details": "static-1.9625",
  "marketplace-ui-reviews": "static-1.19685",
  "marketplace-ui-tracking": "static-1.13900",
  "sanitize-text": "static-1.8149",
  "ui-addon-video-player": "static-1.8710",
  "usage-tracker-multi": "static-1.5765",
  "usage-tracker-session-replay": "static-1.5037",
  "wootric-nps": "static-1.6982",
  "quartz-head": "static-1.707",
  "web-vitals": "static-1.5",
  "apollo-link-hub-http": "static-2.4658",
  "immer": "static-1.33",
  "immerable": "static-1.4162",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67572",
  "cssUtils": "static-1.794",
  "flux-actions": "static-1.338",
  "HubStyle": "static-2.11785",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10214",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10372",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7341",
  "icons": "static-2.647",
  "marketplace-ui-apps-core": "static-1.18262",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4523",
  "foundations-components-test-utils": "static-1.5434",
  "quartz-i18n": "static-1.717",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.248",
  "microsoft-drive-integration-lib": "static-1.367",
  "slack-ui-library": "static-1.10400",
  "fsm": "static-1.3737",
  "customer-data-objects": "static-1.7676",
  "property-translator": "static-1.5407",
  "hs-locale-management": "static-1.84",
  "frontend-preferences-client": "static-1.7935",
  "hs-promise-utils": "static-1.5599",
  "hubspot-apollo-client": "static-1.4886",
  "integrations-error-boundary-lib": "static-1.13571",
  "integrations-tracking-lib": "static-1.5608",
  "native-integrations-shared-strings": "static-1.7789",
  "reselect": "static-2.16",
  "sanitize": "static-1.4484",
  "superstore": "static-1.4768",
  "ui-shepherd-react": "static-3.10170",
  "ai-settings-ui-library": "static-1.7898",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4655",
  "immutable-less": "static-1.4661",
  "marketplace-ui-client-types": "static-1.17136",
  "nav-meta": "static-1.29698",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10255",
  "ui-addon-upgrades": "static-9.18004",
  "inbound-db-properties-service-client": "static-1.3849",
  "property-management-common": "static-1.5455",
  "ui-addon-iframeable": "static-1.9065",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.717",
  "quartz-test": "static-1.717",
  "quartz-tracking": "static-1.421",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.69",
  "bender-build-tools": "static-1.3205",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21357",
  "ContentUtils": "static-1.68378",
  "customer-data-objects-ui-components": "static-1.13034",
  "sassPrefix": "static-1.156",
  "avatar-components": "static-1.2503",
  "customer-data-filters-ui": "static-1.39803",
  "customer-data-reference-ui-components": "static-1.13171",
  "embedded-academy-lib": "static-1.14366",
  "ExportDialog": "static-6.10395",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41323",
  "reporting-snowflake": "static-1.56190",
  "reporting-ui-components": "static-2.64843",
  "reporting-visualizations": "static-1.59648",
  "ui-addon-teams": "static-1.21562",
  "magpie-lib": "static-1.5556",
  "navigation-components": "static-1.18061",
  "magpie-types": "static-1.5016",
  "simple-logging-lib": "static-1.3057",
  "ai-studio-lib": "static-1.11625",
  "app-governance-lib": "static-1.1550",
  "developer-experience-shared-components": "static-1.10516",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8005",
  "ui-product-approvals": "static-1.28154",
  "ui-tool-access": "static-1.10154",
  "usage-based-billing-components-lib": "static-1.8910",
  "usage-tracker-anonymous": "static-1.5768",
  "usage-tracker-public": "static-1.7162",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3589",
  "persist-promise": "static-1.3705",
  "reference-resolvers": "static-1.8178",
  "ui-extensibility-client-types": "static-1.3931",
  "hubspot-apollo-cache": "static-1.345",
  "universal-page-editor-lib": "static-1.3019",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2791",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5079",
  "purchase-motions-components": "static-1.5915",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1548",
  "crm-component-utils": "static-1.39087",
  "crm-properties-common-lib": "static-1.5892",
  "customer-data-properties": "static-1.51566",
  "framework-data-schema-resolvers": "static-1.6892",
  "property-value-citations": "static-1.2180",
  "reference-resolvers-lite": "static-1.8101",
  "ui-business-units-lib": "static-1.9062",
  "navigation-messaging": "static-1.7388",
  "hubspotter-http-shared-msw-handlers": "static-1.9972",
  "cms-field-types": "static-1.4819",
  "content-icons-ui": "static-1.2229",
  "customer-data-ui-utilities": "static-1.9834",
  "events-data-lib": "static-1.228",
  "conversations-skeleton-state": "static-1.7254",
  "crm-message-bus": "static-1.43002",
  "customer-data-filters-ui-msw-helpers": "static-1.22238",
  "FormUrlGenerator": "static-2.4726",
  "framework-builder-read-service-client": "static-1.4008",
  "framework-data-schema-quick-fetch": "static-1.6797",
  "multi-account-reference-resolvers": "static-1.987",
  "onboarding-tours": "static-1.16624",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13695",
  "academy-common-lib": "static-1.13826",
  "content-assistance-lib": "static-1.7764",
  "dashboard-lib": "static-1.81552",
  "file-manager-components": "static-1.23644",
  "getting-started-shared-tasks": "static-1.18480",
  "hubspot-prosemirror": "static-1.18245",
  "hubspot-prosemirror-plugins": "static-1.18237",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19850",
  "share-with-third-party-component-lib": "static-1.8709",
  "ui-addon-draggable": "static-3.4769",
  "ui-asset-management-lib": "static-1.11042",
  "user-context": "static-1.5113",
  "growth-payments-core": "static-1.25390",
  "reporting-plugins": "static-1.10337",
  "reporting-reports": "static-1.67250",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.731",
  "nest": "static-1.233",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10634",
  "framework-listing-lib": "static-2.28718",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30726",
  "apps-service-types": "static-1.3885",
  "oauth-service-types": "static-1.4256",
  "ui-product-approvals-common": "static-1.49",
  "onboarding-scopes": "static-1.6469",
  "onboarding-tours-client": "static-1.4838",
  "platform-infra-nav-components": "static-1.7673",
  "subscription-experience-data-types": "static-1.14946",
  "crm-record-cards-service-types": "static-1.3600",
  "location-customization-utils-lib": "static-1.9273",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5918",
  "signup-constants": "static-1.18849",
  "signup-ui-url-generator": "static-2.8056",
  "trials-service-types": "static-1.3910",
  "card-properties-lib": "static-1.44207",
  "commerce-subscription-lib": "static-1.37131",
  "crm-actions": "static-1.6332",
  "crm-cards-sdk": "static-1.43600",
  "customer-data-properties-shared-msw-handlers": "static-1.9301",
  "customer-data-tracking": "static-1.6896",
  "hs-resources": "static-1.157",
  "pulse": "static-1.581",
  "calling-global-api": "static-1.64525",
  "calling-internal-common": "static-1.31310",
  "calling-lifecycle-internal": "static-1.65907",
  "calling-lifecycle-messages": "static-1.58201",
  "commerce-products-lib": "static-1.9582",
  "conditional-properties-service-client": "static-1.3800",
  "crm-links": "static-1.6301",
  "external-options-client-types": "static-1.4162",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4226",
  "meetings-icalendar-utils-lib": "static-1.638",
  "multi-currency-client-types": "static-1.3694",
  "object-builder-ui-client": "static-1.48761",
  "pipeline-validation-client-types": "static-1.3968",
  "smart-property-lib": "static-1.7074",
  "tiered-pricing": "static-1.1234",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.10997",
  "crm-pipelines-api-client-types": "static-1.4142",
  "fdsr-migration-layer": "static-1.11",
  "react-dnd-compat": "static-1.4622",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.906",
  "growth-data-modal": "static-1.5441",
  "growth-onboarding-confetti": "static-1.3073",
  "growth-onboarding-next-action-utils": "static-1.1931",
  "onboarding-tours-utils": "static-1.690",
  "ui-shepherd-tracker": "static-1.7551",
  "academy-service-client": "static-1.3688",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39143",
  "FileManagerLib": "static-1.39284",
  "video-embed": "static-1.35772",
  "ui-coaching-tips": "static-1.28569",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11280",
  "video-data-lib": "static-1.34938",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23550",
  "ui-addon-emoji-picker": "static-1.9895",
  "EmailSignatureEditor": "static-1.24385",
  "viral-links-lib": "static-1.7069",
  "data-token-picker": "static-1.16423",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.234",
  "timezone-utils": "static-2.5251",
  "seat-types-lib": "static-1.20",
  "getting-started-shared-tasks-store": "static-1.17598",
  "ui-addon-opt": "static-4.8374",
  "campaign-roi-lib": "static-1.9134",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7333",
  "customer-data-views-management": "static-1.25468",
  "framework-data-table": "static-2.11934",
  "marketing-platform-lib": "static-1.6865",
  "nudge-client-utils": "static-1.2594",
  "nudge-custom-ui-functions": "static-1.1038",
  "app-users-service-client": "static-1.5605",
  "app-users-service-types": "static-1.5013",
  "mini-checkout-client": "static-1.26826",
  "onboarding-utils": "static-1.5361",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28554",
  "edison-service-client-types": "static-1.395",
  "crm_data": "static-4.91981",
  "customer-data-sidebar": "static-2.46027",
  "enrichment-properties-lib": "static-1.16192",
  "ui-addon-draggable-compat": "static-2.4263",
  "commerce-billing-lib": "static-1.19080",
  "commerce-shared-components-lib": "static-1.18553",
  "commerce-tools-ui-lib": "static-1.10385",
  "crm-fe-perf": "static-1.22910",
  "bend-plugin-pulse": "static-1.84",
  "directed-graph": "static-1.943",
  "event-emitter": "static-1.955",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31317",
  "shared-worker-versioning": "static-1.11043",
  "calling-usage-tracker": "static-1.6548",
  "voice-sms-access-library": "static-1.989",
  "commerce-permissions": "static-1.776",
  "products-iframe-lib": "static-1.7947",
  "products-ui-components-shared-msw-handlers": "static-1.10356",
  "data-agent-kit": "static-1.204",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10057",
  "policy-lib": "static-1.6785",
  "react-tinymce": "static-1.55254",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10120",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54380",
  "tinymce-plugins": "static-1.57494",
  "tinymce-themes": "static-1.56350",
  "onboarding-data-sync-lib": "static-1.1970",
  "growth-onboarding-next-action-components": "static-1.1959",
  "user-context-client": "static-1.4620",
  "audio-components": "static-1.5926",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36795",
  "urlinator": "static-1.4544",
  "video-components": "static-1.13283",
  "outpost": "static-1.4189",
  "growth-onboarding-feedback-components": "static-1.6588",
  "content-media-composition-data-lib": "static-1.12316",
  "content-media-compositions": "static-2.16323",
  "media-bridge-lib": "static-1.18941",
  "commerce-tours-lib": "static-1.6112",
  "growth-onboarding-reliability": "static-1.5089",
  "sales-checkout-service-client": "static-1.3647",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21693",
  "sales-email-signature-service-client": "static-1.3850",
  "ts-utils-lib": "static-1.180",
  "breeze-engine-lib": "static-1.672",
  "crm-export-dialog": "static-1.6300",
  "crm-index-associations-lib": "static-1.6448",
  "crm-view-components": "static-1.264",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2351",
  "nudge-renderer-utils": "static-1.2670",
  "whisper-core-api": "static-1.6632",
  "InboxConnectUtils": "static-4.14824",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5564",
  "settings-content-modals": "static-1.46092",
  "crm_universal": "static-1.22023",
  "customer-data-email": "static-1.18050",
  "card-payment-highlight-lib": "static-1.37187",
  "card-subscription-highlight-lib": "static-1.39554",
  "commerce-contract-lib": "static-1.12071",
  "invoices-highlight-card-lib": "static-1.54742",
  "orders-highlight-card-lib": "static-1.21481",
  "products-highlight-card-lib": "static-1.17865",
  "quotes-highlight-card-lib": "static-1.72058",
  "crm-source-interpretation-lib": "static-1.5350",
  "utility-belt": "static-1.2542",
  "payments-enrollment-embed-lib": "static-1.22888",
  "stripe-embedded-components": "static-1.7521",
  "customer-data-rte": "static-1.33007",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5742",
  "payments-post-enroll-local-storage-lib": "static-1.5115",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38148",
  "calling-orchestration-schema": "static-1.35766",
  "sales-views-client-types": "static-1.4266",
  "hub-http-contrib": "static-1.3050",
  "interframe": "static-3.4767",
  "tinymce-data": "static-1.40465",
  "ui-addon-sales-email": "static-1.5218",
  "layout-dnd-components": "static-1.12463",
  "layout-dnd-utils": "static-1.11438",
  "ui-brand-identity-lib": "static-1.15295",
  "NamespacedHubStyle": "static-2.9062",
  "meetings-connect-utils-lib": "static-1.7612",
  "social-insights-client-types": "static-1.22123",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4147",
  "checkout-sdk": "static-3.23669",
  "checkout-service-types": "static-1.3824",
  "company-details-components": "static-1.6203",
  "payment-method-components": "static-1.6914",
  "pricing-pages-ui-components": "static-1.14027",
  "quote-checkout-service-types": "static-1.3474",
  "upgrade-catalog-service-types": "static-1.3527",
  "access-control-lib": "static-1.10443",
  "EmailComponents": "static-1.54756",
  "EmailData": "static-1.53433",
  "redux-less": "static-2.9490",
  "sequences-lib": "static-1.8057",
  "ui-gdpr-components": "static-1.10357",
  "products-ui-components": "static-1.40100",
  "accounting-integrations-ui-components": "static-1.7078",
  "invoices-ui-lib": "static-1.54758",
  "commerce-products-api": "static-1.2305",
  "invoices-iframe-lib": "static-1.56816",
  "quotes-modal-lib": "static-1.102736",
  "quotes-ui-lib": "static-1.80779",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28277",
  "ContentData": "static-1.68453",
  "layout-data-lib": "static-1.9763",
  "hub-http-rxjs": "static-1.802",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3946",
  "billing-payments-client-types": "static-1.3996",
  "react-performance-metrics-lib": "static-1.562",
  "account-and-billing-fintech-outages": "static-3.18600",
  "pricing-pages-api": "static-1.13892",
  "ContentComponents": "static-2.71334",
  "marketing-contacts-lib": "static-1.10056",
  "marketing-email-service-types": "static-1.1919",
  "messaging-editing-lib": "static-1.46286",
  "messaging-usage-based-billing-components-lib": "static-1.1148",
  "automation-ui-source-apps": "static-1.18901",
  "automation-ui-types": "static-1.19819",
  "messaging-types-lib": "static-1.46023",
  "onboarding-settings-client": "static-1.4512",
  "sequences-client-types-lib": "static-1.7914",
  "commerce-tax-lib": "static-1.534",
  "price-books-api": "static-1.752",
  "price-books-components": "static-1.810",
  "property-description-translator": "static-1.3851",
  "ramp-editor": "static-1.168",
  "commerce-analytics-service-client": "static-1.3635",
  "totals-ui-components": "static-1.23611",
  "SalesContentIndexUI": "static-3.9259",
  "advanced-menus-core": "static-1.15140",
  "advanced-menus-lib": "static-1.12079",
  "ui-memberships-settings-lib": "static-1.34058",
  "segments-query-core": "static-1.1426",
  "demographics-service-types": "static-1.1659",
  "eligibility-engine-service-types": "static-1.3191",
  "automation-ui-ubb": "static-1.5735",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7346",
  "data-token-views": "static-1.16404",
  "forms-utils-lib": "static-1.12599",
  "payments-embed-points-lib": "static-1.13050",
  "simple-menus-core": "static-1.15139",
  "simple-menus-lib": "static-1.16656",
  "videoconference-integration-components": "static-1.6830",
  "marketing-contacts-client": "static-1.7525",
  "automation-applications-service-types": "static-1.3514",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77131",
  "short-messages-app-service-client": "static-1.3976",
  "web-interactives-components": "static-1.13776",
  "web-interactives-data": "static-1.13777",
  "messaging-shared-utils-lib": "static-1.597",
  "messaging-user-info-utils-lib": "static-1.767",
  "email-portal-health-service-types": "static-1.984",
  "line-items-api": "static-1.705",
  "commerce-totals-service-types": "static-1.3822",
  "FireAlarmUi": "static-1.4516",
  "sales-templates-service-types-lib": "static-1.4173",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21755",
  "automation-ui-usage-tracking": "static-1.21218",
  "data-studio-ubb": "static-1.2739",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27041",
  "collaboration-sidebar": "static-1.57825",
  "content-management-data-lib": "static-1.5394",
  "copilot-plugins": "static-1.11123",
  "cta-picker": "static-1.36413",
  "customer-agent-discovery-components-lib": "static-1.3096",
  "editor-components": "static-1.13238",
  "editor-iframe-lib": "static-1.8413",
  "error-messaging-js": "static-1.5200",
  "FormsCommonComponents": "static-1.85862",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10653",
  "SharedLegalStrings": "static-1.1754",
  "smart-content-core": "static-1.42454",
  "smart-content-lib": "static-1.43107",
  "social-composer-lib": "static-1.59141",
  "structured-content-lib": "static-1.25202",
  "theme-previewer-lib": "static-1.53267",
  "tinymce-copilot": "static-1.16448",
  "xray-recommendation-lib": "static-1.7914",
  "automation-ui-routing": "static-1.21176",
  "sql-reporting-client-types": "static-1.5647",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42211",
  "campaigns-utils-lib": "static-1.3186",
  "reporting-enablement": "static-1.22942",
  "chatspot-widget-iframe": "static-1.21348",
  "collaboration-sidebar-common": "static-1.2622",
  "forms-ai-lib": "static-1.4331",
  "codemirror-dlb": "static-1.58690",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6438",
  "report-customization-components": "static-1.13191",
  "data-quality-ui-library": "static-1.13050",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.340",
  "reporting-insights-lib": "static-1.1760"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12280",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9676",
  "foundations-components": "/foundations-components/static-1.7951",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.976",
  "foundations-theming": "/foundations-theming/static-1.4425",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8020",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9974",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11478",
  "I18n": "/I18n/static-7.1628",
  "jasmine-runner": "/jasmine-runner/static-1.6471",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12341",
  "quartz": "/quartz/static-1.7042",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16679",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2865",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9505",
  "settings-ui-lib": "/settings-ui-lib/static-1.12528",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7151",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11156",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9549",
  "unified-auth": "/unified-auth/static-1.500",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.782",
  "usage-tracker": "/usage-tracker/static-1.7351",
  "usage-tracker-core": "/usage-tracker-core/static-1.7201",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8097",
  "hub-http": "/hub-http/static-1.6229",
  "integrations-lib": "/integrations-lib/static-1.16156",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19729",
  "property-management-iframe": "/property-management-iframe/static-1.13167",
  "quartz-config": "/quartz-config/static-1.820",
  "quartz-core": "/quartz-core/static-1.6261",
  "quartz-routing": "/quartz-routing/static-1.472",
  "quick-fetch": "/quick-fetch/static-1.3920",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4659",
  "ts-schema": "/ts-schema/static-1.4083",
  "ui-universal-auth": "/ui-universal-auth/static-1.8986",
  "UIComponents": "/UIComponents/static-3.8424",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3403",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3319",
  "quartz-webpack": "/quartz-webpack/static-1.3266",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.120",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4220",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4872",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2141",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9432",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5348",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1967",
  "ui-fonts": "/ui-fonts/static-1.740",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2908",
  "foundations-theming-base": "/foundations-theming-base/static-1.3410",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3131",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4334",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8997",
  "ai-rendering-library": "/ai-rendering-library/static-1.10190",
  "chirp-fetch": "/chirp-fetch/static-1.1895",
  "connections-embed-lib": "/connections-embed-lib/static-1.1005",
  "copilot-toolkit": "/copilot-toolkit/static-1.11150",
  "feedback-loader": "/feedback-loader/static-1.29309",
  "laboratory-lib": "/laboratory-lib/static-3.7163",
  "marketplace-embed": "/marketplace-embed/static-1.22101",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9625",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19685",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13900",
  "sanitize-text": "/sanitize-text/static-1.8149",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8710",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5765",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5037",
  "wootric-nps": "/wootric-nps/static-1.6982",
  "quartz-head": "/quartz-head/static-1.707",
  "web-vitals": "/web-vitals/static-1.5",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4658",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4162",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67572",
  "cssUtils": "/cssUtils/static-1.794",
  "flux-actions": "/flux-actions/static-1.338",
  "HubStyle": "/HubStyle/static-2.11785",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10214",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10372",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7341",
  "icons": "/icons/static-2.647",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18262",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4523",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5434",
  "quartz-i18n": "/quartz-i18n/static-1.717",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.248",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.367",
  "slack-ui-library": "/slack-ui-library/static-1.10400",
  "fsm": "/fsm/static-1.3737",
  "customer-data-objects": "/customer-data-objects/static-1.7676",
  "property-translator": "/property-translator/static-1.5407",
  "hs-locale-management": "/hs-locale-management/static-1.84",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7935",
  "hs-promise-utils": "/hs-promise-utils/static-1.5599",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4886",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13571",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5608",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7789",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4484",
  "superstore": "/superstore/static-1.4768",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10170",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7898",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4655",
  "immutable-less": "/immutable-less/static-1.4661",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17136",
  "nav-meta": "/nav-meta/static-1.29698",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10255",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18004",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3849",
  "property-management-common": "/property-management-common/static-1.5455",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9065",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.717",
  "quartz-test": "/quartz-test/static-1.717",
  "quartz-tracking": "/quartz-tracking/static-1.421",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21357",
  "ContentUtils": "/ContentUtils/static-1.68378",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13034",
  "sassPrefix": "/sassPrefix/static-1.156",
  "avatar-components": "/avatar-components/static-1.2503",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39803",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13171",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14366",
  "ExportDialog": "/ExportDialog/static-6.10395",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41323",
  "reporting-snowflake": "/reporting-snowflake/static-1.56190",
  "reporting-ui-components": "/reporting-ui-components/static-2.64843",
  "reporting-visualizations": "/reporting-visualizations/static-1.59648",
  "ui-addon-teams": "/ui-addon-teams/static-1.21562",
  "magpie-lib": "/magpie-lib/static-1.5556",
  "navigation-components": "/navigation-components/static-1.18061",
  "magpie-types": "/magpie-types/static-1.5016",
  "simple-logging-lib": "/simple-logging-lib/static-1.3057",
  "ai-studio-lib": "/ai-studio-lib/static-1.11625",
  "app-governance-lib": "/app-governance-lib/static-1.1550",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10516",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8005",
  "ui-product-approvals": "/ui-product-approvals/static-1.28154",
  "ui-tool-access": "/ui-tool-access/static-1.10154",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8910",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5768",
  "usage-tracker-public": "/usage-tracker-public/static-1.7162",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3589",
  "persist-promise": "/persist-promise/static-1.3705",
  "reference-resolvers": "/reference-resolvers/static-1.8178",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3931",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.345",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3019",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2791",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5079",
  "purchase-motions-components": "/purchase-motions-components/static-1.5915",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1548",
  "crm-component-utils": "/crm-component-utils/static-1.39087",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5892",
  "customer-data-properties": "/customer-data-properties/static-1.51566",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6892",
  "property-value-citations": "/property-value-citations/static-1.2180",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8101",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9062",
  "navigation-messaging": "/navigation-messaging/static-1.7388",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9972",
  "cms-field-types": "/cms-field-types/static-1.4819",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9834",
  "events-data-lib": "/events-data-lib/static-1.228",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7254",
  "crm-message-bus": "/crm-message-bus/static-1.43002",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22238",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4726",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4008",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6797",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.987",
  "onboarding-tours": "/onboarding-tours/static-1.16624",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13695",
  "academy-common-lib": "/academy-common-lib/static-1.13826",
  "content-assistance-lib": "/content-assistance-lib/static-1.7764",
  "dashboard-lib": "/dashboard-lib/static-1.81552",
  "file-manager-components": "/file-manager-components/static-1.23644",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18480",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18245",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18237",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19850",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8709",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4769",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11042",
  "user-context": "/user-context/static-1.5113",
  "growth-payments-core": "/growth-payments-core/static-1.25390",
  "reporting-plugins": "/reporting-plugins/static-1.10337",
  "reporting-reports": "/reporting-reports/static-1.67250",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.731",
  "nest": "/nest/static-1.233",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10634",
  "framework-listing-lib": "/framework-listing-lib/static-2.28718",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30726",
  "apps-service-types": "/apps-service-types/static-1.3885",
  "oauth-service-types": "/oauth-service-types/static-1.4256",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.49",
  "onboarding-scopes": "/onboarding-scopes/static-1.6469",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4838",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7673",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14946",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3600",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9273",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5918",
  "signup-constants": "/signup-constants/static-1.18849",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8056",
  "trials-service-types": "/trials-service-types/static-1.3910",
  "card-properties-lib": "/card-properties-lib/static-1.44207",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37131",
  "crm-actions": "/crm-actions/static-1.6332",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43600",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9301",
  "customer-data-tracking": "/customer-data-tracking/static-1.6896",
  "hs-resources": "/hs-resources/static-1.157",
  "pulse": "/pulse/static-1.581",
  "calling-global-api": "/calling-global-api/static-1.64525",
  "calling-internal-common": "/calling-internal-common/static-1.31310",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65907",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58201",
  "commerce-products-lib": "/commerce-products-lib/static-1.9582",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3800",
  "crm-links": "/crm-links/static-1.6301",
  "external-options-client-types": "/external-options-client-types/static-1.4162",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4226",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.638",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3694",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48761",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3968",
  "smart-property-lib": "/smart-property-lib/static-1.7074",
  "tiered-pricing": "/tiered-pricing/static-1.1234",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10997",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4142",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.11",
  "react-dnd-compat": "/react-dnd-compat/static-1.4622",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.906",
  "growth-data-modal": "/growth-data-modal/static-1.5441",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3073",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1931",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.690",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7551",
  "academy-service-client": "/academy-service-client/static-1.3688",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39143",
  "FileManagerLib": "/FileManagerLib/static-1.39284",
  "video-embed": "/video-embed/static-1.35772",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28569",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11280",
  "video-data-lib": "/video-data-lib/static-1.34938",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23550",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9895",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24385",
  "viral-links-lib": "/viral-links-lib/static-1.7069",
  "data-token-picker": "/data-token-picker/static-1.16423",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.234",
  "timezone-utils": "/timezone-utils/static-2.5251",
  "seat-types-lib": "/seat-types-lib/static-1.20",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17598",
  "ui-addon-opt": "/ui-addon-opt/static-4.8374",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9134",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7333",
  "customer-data-views-management": "/customer-data-views-management/static-1.25468",
  "framework-data-table": "/framework-data-table/static-2.11934",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6865",
  "nudge-client-utils": "/nudge-client-utils/static-1.2594",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1038",
  "app-users-service-client": "/app-users-service-client/static-1.5605",
  "app-users-service-types": "/app-users-service-types/static-1.5013",
  "mini-checkout-client": "/mini-checkout-client/static-1.26826",
  "onboarding-utils": "/onboarding-utils/static-1.5361",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28554",
  "edison-service-client-types": "/edison-service-client-types/static-1.395",
  "crm_data": "/crm_data/static-4.91981",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46027",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16192",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4263",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19080",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18553",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10385",
  "crm-fe-perf": "/crm-fe-perf/static-1.22910",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.84",
  "directed-graph": "/directed-graph/static-1.943",
  "event-emitter": "/event-emitter/static-1.955",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31317",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11043",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6548",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.989",
  "commerce-permissions": "/commerce-permissions/static-1.776",
  "products-iframe-lib": "/products-iframe-lib/static-1.7947",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10356",
  "data-agent-kit": "/data-agent-kit/static-1.204",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10057",
  "policy-lib": "/policy-lib/static-1.6785",
  "react-tinymce": "/react-tinymce/static-1.55254",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10120",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54380",
  "tinymce-plugins": "/tinymce-plugins/static-1.57494",
  "tinymce-themes": "/tinymce-themes/static-1.56350",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1970",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1959",
  "user-context-client": "/user-context-client/static-1.4620",
  "audio-components": "/audio-components/static-1.5926",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36795",
  "urlinator": "/urlinator/static-1.4544",
  "video-components": "/video-components/static-1.13283",
  "outpost": "/outpost/static-1.4189",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6588",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12316",
  "content-media-compositions": "/content-media-compositions/static-2.16323",
  "media-bridge-lib": "/media-bridge-lib/static-1.18941",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6112",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5089",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3647",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21693",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3850",
  "ts-utils-lib": "/ts-utils-lib/static-1.180",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.672",
  "crm-export-dialog": "/crm-export-dialog/static-1.6300",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6448",
  "crm-view-components": "/crm-view-components/static-1.264",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2351",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2670",
  "whisper-core-api": "/whisper-core-api/static-1.6632",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14824",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5564",
  "settings-content-modals": "/settings-content-modals/static-1.46092",
  "crm_universal": "/crm_universal/static-1.22023",
  "customer-data-email": "/customer-data-email/static-1.18050",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37187",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39554",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12071",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54742",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21481",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17865",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72058",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5350",
  "utility-belt": "/utility-belt/static-1.2542",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22888",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7521",
  "customer-data-rte": "/customer-data-rte/static-1.33007",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5742",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5115",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38148",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35766",
  "sales-views-client-types": "/sales-views-client-types/static-1.4266",
  "hub-http-contrib": "/hub-http-contrib/static-1.3050",
  "interframe": "/interframe/static-3.4767",
  "tinymce-data": "/tinymce-data/static-1.40465",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5218",
  "layout-dnd-components": "/layout-dnd-components/static-1.12463",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11438",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15295",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9062",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7612",
  "social-insights-client-types": "/social-insights-client-types/static-1.22123",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4147",
  "checkout-sdk": "/checkout-sdk/static-3.23669",
  "checkout-service-types": "/checkout-service-types/static-1.3824",
  "company-details-components": "/company-details-components/static-1.6203",
  "payment-method-components": "/payment-method-components/static-1.6914",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14027",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3474",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3527",
  "access-control-lib": "/access-control-lib/static-1.10443",
  "EmailComponents": "/EmailComponents/static-1.54756",
  "EmailData": "/EmailData/static-1.53433",
  "redux-less": "/redux-less/static-2.9490",
  "sequences-lib": "/sequences-lib/static-1.8057",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10357",
  "products-ui-components": "/products-ui-components/static-1.40100",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7078",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54758",
  "commerce-products-api": "/commerce-products-api/static-1.2305",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56816",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102736",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80779",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28277",
  "ContentData": "/ContentData/static-1.68453",
  "layout-data-lib": "/layout-data-lib/static-1.9763",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.802",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3946",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3996",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.562",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18600",
  "pricing-pages-api": "/pricing-pages-api/static-1.13892",
  "ContentComponents": "/ContentComponents/static-2.71334",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10056",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1919",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46286",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1148",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18901",
  "automation-ui-types": "/automation-ui-types/static-1.19819",
  "messaging-types-lib": "/messaging-types-lib/static-1.46023",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4512",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7914",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.534",
  "price-books-api": "/price-books-api/static-1.752",
  "price-books-components": "/price-books-components/static-1.810",
  "property-description-translator": "/property-description-translator/static-1.3851",
  "ramp-editor": "/ramp-editor/static-1.168",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3635",
  "totals-ui-components": "/totals-ui-components/static-1.23611",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9259",
  "advanced-menus-core": "/advanced-menus-core/static-1.15140",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12079",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34058",
  "segments-query-core": "/segments-query-core/static-1.1426",
  "demographics-service-types": "/demographics-service-types/static-1.1659",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3191",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5735",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7346",
  "data-token-views": "/data-token-views/static-1.16404",
  "forms-utils-lib": "/forms-utils-lib/static-1.12599",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13050",
  "simple-menus-core": "/simple-menus-core/static-1.15139",
  "simple-menus-lib": "/simple-menus-lib/static-1.16656",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6830",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7525",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3514",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77131",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3976",
  "web-interactives-components": "/web-interactives-components/static-1.13776",
  "web-interactives-data": "/web-interactives-data/static-1.13777",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.597",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.767",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.984",
  "line-items-api": "/line-items-api/static-1.705",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3822",
  "FireAlarmUi": "/FireAlarmUi/static-1.4516",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4173",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21755",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21218",
  "data-studio-ubb": "/data-studio-ubb/static-1.2739",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27041",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57825",
  "content-management-data-lib": "/content-management-data-lib/static-1.5394",
  "copilot-plugins": "/copilot-plugins/static-1.11123",
  "cta-picker": "/cta-picker/static-1.36413",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3096",
  "editor-components": "/editor-components/static-1.13238",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8413",
  "error-messaging-js": "/error-messaging-js/static-1.5200",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85862",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10653",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1754",
  "smart-content-core": "/smart-content-core/static-1.42454",
  "smart-content-lib": "/smart-content-lib/static-1.43107",
  "social-composer-lib": "/social-composer-lib/static-1.59141",
  "structured-content-lib": "/structured-content-lib/static-1.25202",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53267",
  "tinymce-copilot": "/tinymce-copilot/static-1.16448",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7914",
  "automation-ui-routing": "/automation-ui-routing/static-1.21176",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5647",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42211",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3186",
  "reporting-enablement": "/reporting-enablement/static-1.22942",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21348",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2622",
  "forms-ai-lib": "/forms-ai-lib/static-1.4331",
  "codemirror-dlb": "/codemirror-dlb/static-1.58690",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6438",
  "report-customization-components": "/report-customization-components/static-1.13191",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13050",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.340",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1760"
}
};
